import { AppService } from './app.service';

export * from './app.service';
export * from './logging.service';

export const services = [AppService];
